exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-bg[data-v-4cd3b1be]{position:absolute;left:0;top:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.8);display:flex;justify-content:center;align-items:center;transition:opacity .3s ease}.activity-overlay-enter[data-v-4cd3b1be],.activity-overlay-leave-active[data-v-4cd3b1be]{opacity:0}.title[data-v-4cd3b1be]{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cd3b1be","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/shared/components/ActivityOverlay.vue
// module id = 76
// module chunks = 0 1 3 4